import { useSearchParams } from 'next/navigation';
import { useMemo } from 'react';
import { getDiscountPercent, getDiscountPrice } from '@/entities/cart';
import { PriceWithDiscount, QuantityDiscount } from '@/entities/product';
import { prepareQuantity } from '../../lib/quantityUtils';

interface SelectedProductPriceProps {
  slug: string;
  price: number;
  quantityDiscounts?: QuantityDiscount[];
}

const SelectedProductPrice = ({ slug, price, quantityDiscounts }: SelectedProductPriceProps) => {
  const searchParams = useSearchParams();

  const quantity = prepareQuantity(searchParams?.get('quantity'));

  const discount = useMemo(
    () => getDiscountPercent(slug, Number(quantity), quantityDiscounts),
    [quantity, quantityDiscounts, slug],
  );

  const discountPrice = useMemo(
    () => getDiscountPrice(slug, Number(quantity), quantityDiscounts),
    [quantity, quantityDiscounts, slug],
  );

  return (
    <PriceWithDiscount
      discountPercent={discount}
      discountPrice={discountPrice}
      fontSize='3xl'
      mt='-sm'
      price={price * quantity}
    />
  );
};

export default SelectedProductPrice;
